var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',[_c('RightArrow',{staticClass:"row-span-2",class:_vm.classesButton})],1)}
var staticRenderFns = []

export { render, staticRenderFns }